module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_7016.361b51d6.png";